var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.type,_vm._b({tag:"component",staticClass:"en-result",attrs:{"icon-size":_vm.iconSize}},'component',this.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }